module.exports = __webpack_public_path__ + "static/media/NoThumbnail.c9f7f48d.jpg";